import MapBoxGeocoder from "@mapbox/mapbox-gl-geocoder";
import { useControl } from "react-map-gl";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import { useContext } from "react";
import PersonalAddressContext from "../../_helper/PersonalAddress";
import axios from "axios";
import mapboxgl from "mapbox-gl";

import "../../style/custom-css/PersonalInfo.css";

const Geocoder = ({ updateAddress, setSaveEnable }) => {
  const {
    setAddress1,
    setAddress2,
    setArea,
    setCity,
    setState,
    setPostalCode,
    setCountry,
    setLatitude,
    setLongitude,
    setIsGeocoderCalled,
  } = useContext(PersonalAddressContext);

  const ctrl = new MapBoxGeocoder({
    accessToken:
      "pk.eyJ1IjoibW9uaXJ1enphbWFuLTE4IiwiYSI6ImNsODJtNzNwYjAycHkzdmtwd3hmbmRtdHcifQ.UyNVkQ3MchruzvNqMrVaGQ",
    mapboxgl: mapboxgl,
    marker: false,
    collapsed: false,
    placeholder: "Search Location",
  });

  useControl(() => ctrl);
  ctrl.on("result", (e) => {
    const coords = e.result.geometry.coordinates;
    setLatitude(coords[1]);
    setLongitude(coords[0]);

    var config = {
      method: "get",
      url: `https://api.geoapify.com/v1/geocode/reverse?lat=${coords[1]}&lon=${coords[0]}&apiKey=bcf7acc43f25488fa78a1a008b865556`,
      headers: {},
    };

    axios(config)
      .then(function (response) {
        if (updateAddress) {
          setSaveEnable(true);
        }
        const location = response.data.features[0].properties;
        setAddress1(location.address_line1 || " ");
        setAddress2(location.address_line2 || " ");
        setArea(location.street || " ");
        setCity(location.city || " ");
        setState(location.state || " ");
        setPostalCode(location.postcode || " ");
        setCountry(location.country || " ");
        setIsGeocoderCalled(true);
      })
      .catch(function (error) {
        console.log(error);
      });
  });
  return null;
};

export default Geocoder;
